import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *答题人列表
 * @param params
 * 
*/

export const answerList = params => Http.get(`${baseUrl}/activity/answer`, { params })
